module.exports = __webpack_public_path__ + "static/liva-convert-detail3-a734fd4c7b3b16fa38020ee5ebc236fa.png";